export const staticPages = {
  chartered_sales: {
    backgroundImg: 'bg-[url("/src/images/manonplane.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "Charter Services",
  },
  group_booking: {
    backgroundImg: 'bg-[url("/src/images/peoplewithphones.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "Group Booking",
  },
  cargo_sales: {
    backgroundImg: 'bg-[url("/src/images/aeroplane.svg")] ',
    primaryImg: require("../images/cargoplane.png"),
    primaryImgPosition: "right",
    title: "Cargo Sales",
  },
  corporate_sales: {
    backgroundImg: 'bg-[url("/src/images/aeroplane.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "Corporate Travels",
  },
  travel_agent_sale: {
    backgroundImg: 'bg-[url("/src/images/aeroplane.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "Travel Agency",
  },
  military_fare: {
    backgroundImg: 'bg-[url("/src/images/aeroplane.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "Military Fare",
  },
  nysc_fares: {
    backgroundImg: 'bg-[url("/src/images/aeroplane.svg")] ',
    primaryImg: require("../images/manwithvisa.png"),
    primaryImgPosition: "left",
    title: "NYSC Fares",
  },
};
